<template>
    <div>
        <Navigation v-if="!hideNavigation" />
    </div>

</template>

<script>
import { mapGetters } from 'vuex';
import Navigation from '@/components/Navigation.vue'
export default {
    name: "Header",
    components: { Navigation },
    computed: {
        ...mapGetters('orders', ['hideNavigation'])
    }
}
</script>

<style>

</style>